
const initialState = {
    loginError: false,
    logged_in: false,
};

const signInReducer = (state = initialState, action) => {
    switch (action.type) {
        default: {
            return state;
        }
    }
};

export default signInReducer;


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/Signin/reducer.js